import Swiper from 'swiper/bundle';

export default () => {
  if(document.querySelector('.full-slider__block')){
    let fullSliderBlocks = document.querySelectorAll('.full-slider__block');

    fullSliderBlocks.forEach((fullSliderBlock) => {
      let fullSliderFraction = fullSliderBlock.querySelector('.full-slider__fraction');

      var swiperFull = new Swiper(fullSliderBlock, {
        slidesPerView: 1,
        effect: 'fade',
        navigation: 'true',
        speed: 1500,
        loop: false, 
        pagination: {
          el: ".swiper-pagination",
          dynamicBullets: true,
          clickable: true,
        },
        navigation: {
          nextEl: fullSliderBlock.querySelector('.full-slider__button-next'),
          prevEl: fullSliderBlock.querySelector('.full-slider__button-prev'),
        },
        on: {
          init: (swiperFull) => {
            fractionSet(swiperFull, fullSliderFraction);
          },
          slideChange: (swiperFull) => {
            fractionSet(swiperFull, fullSliderFraction);
          }, 
        }
      });


      function fractionSet(swiperFull, fullSliderFraction){
        
      
        let swiperLength = swiperFull.slides.length;
        let swiperIndex = swiperFull.activeIndex + 1;
  
        if(swiperLength < 10){
          swiperLength = '0'+swiperLength;
        } 
  
        if(swiperIndex < 10){
          swiperIndex = '0'+swiperIndex;
        } 
  
        fullSliderFraction.innerHTML = swiperIndex + '/' + swiperLength;
      }


    });





  }
}